import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { magpCMSApi } from "~/Services";
export type Announcements = Announcement[];

export interface Announcement {
  id: number;
  field_tender_pre_heading_en: string;
  field_tender_pre_heading_zh: string;
  field_tender_pre_heading_ms: string;
  field_tender_calling_date: string;
  field_tender_closing_date: string;
  // field_tender_main_heading: string
  // field_tender_main_heading_zh: string
  // field_tender_main_heading_ms: string
  field_tender_remark: string;
  field_tender_remark_ms: string;
  field_tender_remark_zh: string;
  field_tender_venue: string;
  field_tender_venue_ms: string;
  field_tender_venue_zn: string;
  field_tender_time: string;
  field_tender_content: string;
  field_tender_content_ms: string;
  field_tender_content_zh: string;
  published: boolean;
  createdAt: string;
  updatedAt: string;
  field_tender_updated_at: string;
  field_tender_created_at: string;
  field_tender_created_by: string;
  field_tender_updated_by: string;
}

const fetchAnnouncementDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await magpCMSApi.get(`api/tender-details/all-fields?id=${id}`);
  return response.data[0];
};

const useAnnouncementDetails = (
  id: string,
  options?: UseQueryOptions<Announcement, DefaultError, Announcement, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<Announcement, DefaultError> => {
  return useQuery<Announcement, DefaultError, Announcement, QueryKey>(
    {
      queryKey: ["announcementDrilldownData", id],
      enabled: false,
      queryFn: () => {
        return fetchAnnouncementDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useAnnouncementDetails };
